<template>
  <div v-if="showBanner && bannerData.image_full_pc " class="bannerbutton-comp" :class="{'master-section': bannerData.banner_width, [setCustomClass]: setCustomClass, 'full_width': bannerData.banner_width === 'fullwidth'}" :style="{ paddingBottom: paddingBottomStyle }">
    <div class="master-main-banner_image row mx-0 px-0" :class="{'master-section': bannerData.banner_width}">
      <div class="col-12 px-0 emm-inner-banner" :class="`${bannerData.banner_text_position}`">
        <a v-if="(bannerData.link_type === 'section' || bannerData.link_type === 'alternate') && bannerData.button_link" class="master-section-link" :href="getLangUrl(bannerData?.button_link?.url, baseUrl, locale)" target="<?= $link_target; ?>">
        <!-- Desktop banner image -->
        <img :id="props?.isListing ? 'banner-for-pc' : ''" v-if="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          :alt="bannerData.image_alt_pc || 'image'"
          class="banner-pc img-fluid d-none d-md-inline alt-lazy-img"
        />

        <!-- Mobile banner image -->
        <img
          v-if="bannerData.image_medium_mb"
          :src="bannerData.image_medium_mb"
          :data-original_src="bannerData.image_full_mb"
          :alt="bannerData.image_alt_mb || 'image'"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
        />
        <img
          v-else="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          :alt="bannerData.image_alt_pc || 'image'"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
        />

        <!-- Banner Text Content -->
        <div
          class="master-main-banner-text"
          :class="[
            `${bannerData.mobile_text_position} text-${bannerData.banner_text_position} col-12 col-md-6 offset-md-3 mb-60px`,
            { isListing: isListing }
          ]"
          :style="bannerTextStyle"
          v-if="bannerData.image_medium_pc"
        >
        <Heading
          :level="bannerData.banner_width ? '2' : '1'"
          v-if="bannerData.title"
          :style="{ color: bannerData.banner_text_color }"
          class="agp-normal "
        >
          {{ bannerData.title }}
          <template v-if="bannerData.chinese_title">
            <br>
            {{ bannerData.chinese_title }}
          </template>
        </Heading>

          <!-- Render long_description as HTML -->
          <div
            v-if="bannerData.long_description"
            :style="{ color: bannerData.banner_text_color }"
            class="agp-normal custom_st"
            v-html="textValue"
          ></div>

          <!-- Button -->
             <a
               v-if="bannerData.button_link && bannerData.button_link.title"
               :href="getLangUrl(bannerData?.button_link?.url, baseUrl, locale)"
               :target="bannerData.button_link.target || '_self'"
               class="btn-outline-dark btn "
               :style="buttonStyles"
                @mouseover="hover = true"
                @mouseleave="hover = false"
             >
               {{ bannerData.button_link.title }}
               <span class="css-arrow css-arrow-right" :style="{ borderColor: bannerData.banner_text_color }"></span>
             </a>
        </div>
      </a>
      <div class="img-banner-box" v-else>
          <!-- Desktop banner image -->
          <img :id="props?.isListing ? 'banner-for-pc' : ''" v-if="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          :alt="bannerData.image_alt_pc || 'image'"
          class="banner-pc img-fluid d-none d-md-inline alt-lazy-img"
        />

        <!-- Mobile banner image -->
        <img
          v-if="bannerData.image_medium_mb"
          :src="bannerData.image_medium_mb"
          :data-original_src="bannerData.image_full_mb"
          :alt="bannerData.image_alt_mb || 'image'"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
        />
        <img
          v-else="bannerData.image_medium_pc"
          :src="bannerData.image_medium_pc"
          :data-original_src="bannerData.image_full_pc"
          :alt="bannerData.image_alt_pc || 'image'"
          class="banner-mb img-fluid d-md-none mb-30px alt-lazy-img"
        />

        <!-- Banner Text Content -->
        <div
          class="master-main-banner-text"
          :class="[
            `${bannerData.mobile_text_position} text-${bannerData.banner_text_position} col-12 col-md-6 offset-md-3 mb-60px`,
            { isListing: isListing }
          ]"
          :style="bannerTextStyle"
          v-if="bannerData.image_medium_pc"
        >
        <Heading
          :level="bannerData.banner_width ? '2' : '1'"
          v-if="bannerData.title"
          :style="{ color: bannerData.banner_text_color }"
          class="agp-normal"
          :vHtml="renderedTitle ? bannerData.title : ''"
        >
          <template v-if="!renderedTitle">
            {{ bannerData.title }}
          </template>
          <template v-if="bannerData.chinese_title">
            <br>
            {{ bannerData.chinese_title }}
          </template>
        </Heading>

          <!-- Render long_description as HTML -->
          <div
            v-if="bannerData.long_description"
            :style="{ color: bannerData.banner_text_color }"
            :class="{
              'agp-normal custom_st': true,
              'custom_tilte_shop': props.tax === 'shop'
            }"
            v-html="convertUrlsToLocale(bannerData.long_description, baseUrl, locale)"
          ></div>
          <!-- v-html="textValue" -->
          <!-- Button -->
             <a
               v-if="bannerData.button_link?.url && bannerData.button_link.title && (bannerData.link_type =='button' || bannerData.link_type =='alternate')"
               :href="getLangUrl(bannerData.button_link.url, baseUrl, locale)"
               :target="bannerData.button_link.target || '_self'"
               class="btn-outline-dark btn "
               :style="buttonStyles"
                @mouseover="hover = true"
                @mouseleave="hover = false"
             >
               {{ bannerData.button_link.title }}
               <span class="css-arrow css-arrow-right" :style="{ borderColor: bannerData.banner_text_color }"></span>
             </a>
             <a
               v-if="bannerData.button_link && bannerData.link_type==undefined"
               :href="getLangUrl(bannerData.button_link.url, baseUrl, locale)"
               :target="bannerData.button_link.target || '_self'"
               class="btn-outline-dark btn "
               :style="buttonStyles"
                @mouseover="hover = true"
                @mouseleave="hover = false"
             >
               {{ bannerData.button_link.title }}
               <span class="css-arrow css-arrow-right" :style="{ borderColor: bannerData.banner_text_color }"></span>
             </a>

        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { radians } from 'pdf-lib';
import { ref, computed } from 'vue';
import Heading from '~/components/Heading.vue';
const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
const wooStore = useWooStore();
import { useI18n } from 'vue-i18n';
  const { locale } = useI18n();
  import { getLangUrl, convertUrlsToLocale } from '~/utils/getLangUrl';

// Define the structure of the banner data
interface ButtonLink {
  url?: string;
  target?: string;
  title?: string;
}
interface Bannerimage {
  url?: string;
}
interface BannerData {
  enable_banner: boolean;
  image_medium_pc?: string;
  image_full_pc?: string;
  image_alt_pc?: string;
  image_medium_mb?: string;
  image_full_mb?: string;
  image_alt_mb?: string;
  title?: string;
  long_description?: string;
  banner_text_color?: string;
  text_color_hover?: string;
  button_color?: string;
  button_color_hover?: string;
  button_border?: string;
  max_width_banner_text?: string;
  mobile_text_position?: string;
  banner_text_position?: string;
  button_link?: ButtonLink;
  link_type? : string;
  banner_width? : string;
  chinese_title? : string;
}

// Define the props with type
const props = defineProps<{
  bannerDataProp: BannerData,
  padding_bottom?: string,
  tax?: string, // Optional prop
  isListing?: boolean;
}>();

const setCustomClass = ref('');
const screenWidth = ref(1440);
const updateScreenWidth = () => {
  if (typeof window !== 'undefined') {
    screenWidth.value = window.innerWidth;

    if( props?.isListing ) {
      updateImageHeight(screenWidth.value);
    }
  }


};
// Use a computed property to handle default value
const paddingBottomStyle = computed(() => {
  if (!props.padding_bottom) {
    // Set padding dynamically based on screen width
    // return screenWidth.value < 768 ? '25px' : '60px';
    return screenWidth.value < 768 ? '0px' : '0px';
  }
  return props.padding_bottom;
});

// Use the prop data
const bannerData = ref<BannerData>({
  enable_banner: true, // Default to true
});

const textValue = ref<string>('');
const textLoaded = ref(false);

const updateImageHeight = (w: number) => {
  const bannerImg = document.getElementById("banner-for-pc");
  const listings = document.getElementsByClassName('isListing');

  if( bannerImg && listings.length > 0 ) {
    const listing = listings[0] as HTMLElement;

    if(w < 1024 ) {
      listing.style.top = '';
      listing.style.left = '';
      listing.style.right = '';
      listing.style.transform = '';
      textLoaded.value = true;
      return;
    }

    const textHeight = listing.scrollHeight;
    const imageHeight = bannerImg.offsetHeight;

    const topPosition = (imageHeight - textHeight) / 2;

    if( props.bannerDataProp.banner_text_position !== 'center' ) {
      listing.style.top = `${topPosition}px`;
      listing.style.transform = 'none';
    }else {
      if( w >= 1024 && w < 1281 ) {
        listing.style.top = `${topPosition}px`;
        listing.style.left = `${(w-480)/2}px`;
        listing.style.right = 'auto';
        listing.style.transform = 'none';
      }else {
        listing.style.top = '';
        listing.style.left = '';
        listing.style.right = '';
        listing.style.transform = '';
      }
    }

    textLoaded.value = true;
  }
}

// watch(
//   () => props.bannerDataProp?.long_description,
//   (newValue) => {
//     if (newValue !== undefined) {
//       textValue.value = newValue;
//     }
//   },
//   { immediate: true }
// );

watch(
  () => props.bannerDataProp?.long_description,
  async (newValue) => {
    if (newValue !== undefined) {
      // Use nextTick to ensure the DOM has updated before assigning the value
      await nextTick();
      textValue.value = newValue;
    }
  },
  { immediate: true }
);

onMounted(() => {
  setTimeout(function() {
    updateScreenWidth();
  }, 500);

  if (typeof window !== 'undefined') {
    window.addEventListener('resize', updateScreenWidth); // Add resize event listener
  }
  if(props.bannerDataProp && props.bannerDataProp.long_description !== undefined && bannerData.value.long_description !== ''){
    textValue.value = props.bannerDataProp.long_description;
  }
  setTimeout(() => {
    altLazyIO();
  }, 300);
})

// Watch for changes in props.bannerDataProp and update bannerData accordingly
watchEffect(() => {
  if (props.bannerDataProp) {
    bannerData.value = {
      ...props.bannerDataProp,
      enable_banner: props.bannerDataProp.enable_banner ?? true ,// Default to true if undefined
      long_description: props.bannerDataProp.long_description
    };
  }

});


// Computed property to check if the banner should be displayed
const showBanner = computed(() => {
  return (bannerData.value.enable_banner !== false) && (
    bannerData.value.image_full_pc ||
    bannerData.value.title
  );
});

// Computed property to set banner text style
const bannerTextStyle = computed(() => {
  const maxWidth = bannerData.value.max_width_banner_text ? parseInt(bannerData.value.max_width_banner_text) : 50;

  let customClass = '';
  if (maxWidth <= 100) {
    customClass += 'has-custom';
  }

  if( bannerData.value.button_link?.url && bannerData.value.button_link.title ) {
    customClass += 'has-button';
  }

  setCustomClass.value = customClass;

  return {
    color: bannerData.value.banner_text_color,
    maxWidth: maxWidth > 100
      ? `${maxWidth}px`
      : `${maxWidth}%`
  };
});

// Hover state
const hover = ref(false);

// Computed styles for the button
const buttonStyles = computed(() => ({
  // color: hover.value ? bannerData.value.banner_text_color : bannerData.value.text_color_hover,
  color:  bannerData.value.banner_text_color,
  borderColor: bannerData.value.banner_text_color,
  backgroundColor: hover.value ? bannerData.value.button_color_hover : bannerData.value.button_color,
  transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
  borderRadius: bannerData.value.button_border
}));

// Computed styles for the arrow
const arrowStyles = computed(() => ({
  borderColor: hover.value ? 'transparent' : bannerData.value.banner_text_color,
  transition: 'border-color 0.3s ease-in-out'
}));

function containsHtml(text: string): boolean {
  const htmlTagPattern = /<\/?[\w\s="/.':;#-\/]+>/gi; // Matches any HTML tags
  return htmlTagPattern.test(text);
}

// Computed property to determine if the title should be rendered as HTML
const renderedTitle = computed(() => {
  return containsHtml(bannerData.value.title || '');
});

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', updateScreenWidth); // Remove resize event listener
  }
});
</script>

<style lang="scss">
  @import "@/assets/scss/partials/_bannerbutton.scss";
  // @import "@/assets/scss/components/master-template/_master-template.scss";
  .img-banner-box{
    @media screen and (min-width:769px) {
      min-height: 300px;
    }
  }
  .bannerbutton-comp {
    .agp-normal {
      &.custom_st {
        font-size: 15px;
        letter-spacing: normal;
        line-height: 21px;
        margin-bottom: 0;
        @media (min-width: 768px) and (max-width: 1023px) {
          color: #000 !important;
          margin-bottom: 20px;
        }
        @media screen and (max-width: 767.98px) {
          color: #000 !important;
          margin-bottom: 20px;
        }
      }
    }
    .master-main-banner-text {
      a {
        @media screen and (max-width: 1023.98px) {
          margin-bottom: 20px;
        }
        &.btn-outline-dark {
          @media screen and (max-width: 1023.98px) {
            margin-bottom: 0 !important;
          }
        }
      }
    }
  }
  
</style>
